import actionTypes from '../constants/action-types';

const setNumberOfAiGeneratedBlocks = (count) => ({
  type: actionTypes.SET_NUMBER_OF_AI_GENERATED_BLOCKS,
  payload: { count },
});

export default setNumberOfAiGeneratedBlocks;
